module.exports = __webpack_public_path__ + "0d59020f8d70ac66a4ae541be397c7f9.png";